import { makeApiCall } from '../../../_common/api.utils';
import { API_URL } from '../../../const';

export const fetchAdvancehMemberLoanList = (listData: any) => {
	const data = {
		FetchAdvanceMemberListDataToken: listData,
	};
	const url = `${API_URL}GetDemandForAdvanceCollectionsToken`;
	return makeApiCall(url, data);
};

export const advanceCollectionUpdateAPI = (listData: any) => {
	const data = {
		UpdateAdvanceMemberListData: listData,
	};
	const url = `${API_URL}UpdateAdvanceLoanPaidDetailsToken`;
	return makeApiCall(url, data);
};
